
import { computed, defineComponent, inject, reactive, toRefs } from 'vue'

export default defineComponent({
  name: 'EditableBlockTextField',
  components: {},
  props: {
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number, Array, Object],
      required: true,
    },
    disableEditing: {
      type: Boolean,
      default: false,
    },
    expandable: {
      type: Boolean,
      default: false,
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {

    const inputState = reactive({
      label: props.label,
      value: computed({ get: () => props.modelValue, set: (newValue) => emit('update:modelValue', newValue) })
    })

    const editing = inject('editing', false)

    const state = reactive({
      expanded: null,
    })

    const overflow = computed(() => {
      return (typeof props.modelValue === 'string' && (props.modelValue.match(/\n/g) || []).length + 1 > 4)
    })

    return {
      ...toRefs(state),
      editing,
      inputState,
      overflow
    }
  }
})
